import React from "react";
import Select2 from "react-select2-wrapper";

const GroupSelectTwo = (props) => {
  const {
    label = "",
    name = "",
    empty = "Select",
    divClass = "input-group",
    labelClass = "",
    options,
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      <label className={labelClass}>{label}</label>
      <div className={`${divClass}`}>
        <Select2
          name={name}
          id={props?.id ?? name}
          data={options}
          {...extra}
          options={{
            placeholder: extra.placeholder ?? "",
          }}
        />
        {children ?? ""}
        {errorMsg ?? ""}
      </div>
    </li>
  );
};

export default GroupSelectTwo;
